/* Determina o estilo da placa (Mercosul, antigo ou desconhecido). */
export const getEstiloPlaca = (placa) => {
  if (!placa) return "desconhecido";
  const placaLimpa = placa.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
  if (/^[A-Z]{3}[0-9][A-Z][0-9]{2}$/.test(placaLimpa)) return "mercosul";
  if (/^[A-Z]{3}[0-9]{4}$/.test(placaLimpa)) return "antigo";
  return "desconhecido";
};

/* Formata a placa para exibição, adicionando hífen se for do modelo antigo. */
export const formatarPlaca = (placa) => {
  if (!placa) return "";
  const placaLimpa = placa.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
  if (getEstiloPlaca(placaLimpa) === "antigo") {
    return `${placaLimpa.slice(0, 3)}-${placaLimpa.slice(3)}`;
  }
  return placaLimpa;
};

/* Formata uma duração em milissegundos para o formato "mm:ss". */
export const formatarDuracao = (milissegundos) => {
  if (isNaN(milissegundos) || milissegundos < 0) return "00:00";
  const totalSegundos = Math.round(milissegundos / 1000);
  const minutos = Math.floor(totalSegundos / 60);
  const segundos = totalSegundos % 60;
  return `${String(minutos).padStart(2, "0")}:${String(segundos).padStart(
    2,
    "0",
  )}`;
};

/* Formata o tempo restante em segundos para o formato "mm:ss". */
export const formatTime = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${String(minutes).padStart(2, "0")}:${String(
    remainingSeconds,
  ).padStart(2, "0")}`;
};

const normalizarTexto = (texto) => {
  if (typeof texto !== "string") return "";
  return texto
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();
};

export const formatarMotivoExclusao = (situacao) => {
  const original = typeof situacao === "string" ? situacao.trim() : "";
  if (!original) return "Não informado";

  const chave = normalizarTexto(original);

  const mapa = {
    "foi pago": "O veículo já foi pago",
    pago: "O veículo já foi pago",
    "nao esta com esse escritorio":
      "O veículo não está mais com esse escritório",
    inapto: "O veículo está inapto",
    perdido: "O veículo foi perdido",
    reservado: "Reservar veículo para o LOC",
    apreendido: "O veículo foi apreendido",
    outros: "Outros motivos",
  };

  return mapa[chave] || original;
};
